import { parseTemplate } from 'url-template';
import Atc from '~/Api/Analytics/Atc';
import ApiClient from '~/ApiClient';

export interface Result {
	items: Atc[];
}

export default async function findAtcs(
	client: ApiClient,
	filter: string | null,
	codes: string | null[]
): Promise<Result> {
	const url = parseTemplate('analytics/autocomplete/atcs{?filter,filter-atc}');
	const request = await client.fetch(url.expand({ filter, 'filter-atc': codes }));
	const response = await request.json();
	return {
		items: response.items.map(
			(item: { code: string; activeSubstance: string }) => new Atc(item.code, item.activeSubstance)
		),
	};
}
